import { render, staticRenderFns } from "./MakeMemberTalkNew.vue?vue&type=template&id=4f2b5991&scoped=true&"
import script from "./MakeMemberTalkNew.vue?vue&type=script&lang=js&"
export * from "./MakeMemberTalkNew.vue?vue&type=script&lang=js&"
import style0 from "./MakeMemberTalkNew.vue?vue&type=style&index=0&id=4f2b5991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b5991",
  null
  
)

export default component.exports